import { render, staticRenderFns } from "./LegacyMobileDialog.vue?vue&type=template&id=2c912def&"
import script from "./LegacyMobileDialog.vue?vue&type=script&lang=js&"
export * from "./LegacyMobileDialog.vue?vue&type=script&lang=js&"
import style0 from "./LegacyMobileDialog.vue?vue&type=style&index=0&id=2c912def&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports